import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ZcpPoolClaimBaseEffect } from './zcp-pool-claim-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ ZcpPoolClaimBaseEffect ])
  ]
})
export class ZcpPoolClaimBaseModule {}
